import SearchTextField, { SearchTextFieldStyles } from "@aus/Widgets/WorkOrderHistory/WorkOrderSearchTextField";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import * as React from "react";

export const orderNumberStyles: SearchTextFieldStyles = {};
const styles = orderNumberStyles;

const OrderHistorySearchFieldOrderNumber: React.FunctionComponent<WidgetProps> = () => {
    return (
        <SearchTextField
            styles={styles}
            parameterField="orderNumber"
            label="Work Order #"
            inputType="text"
            placeholder=""
            testSelector="orderHistory_filterOrderNumber"
        />
    );
};

const widgetModule: WidgetModule = {
    component: OrderHistorySearchFieldOrderNumber,
    definition: {
        group: "Order History",
        allowedContexts: ["WorkOrderHistoryPage"] as any,
        displayName: "Work Order Number",
    },
};

export default widgetModule;
